module.exports = __webpack_public_path__ + "img/12_empresarios-trabajan.1edbed89.jpg";